module.exports = __webpack_public_path__ + "res/ic_toggle_off.6a6657541e6433cfc128202b308b54a0.png";